import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import unseal from "./components/unseal.vue";
import { leagueIntroductionChangeList, auditLeagueIntroduction } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { mapActions } from 'vuex';
export default {
  name: "banProcessingList",
  mixins: [gmToolNew, gmToolNewPage],
  components: {
    unseal: unseal
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      paramsData: {
        uids: '',
        start_time: '',
        end_time: '',
        page: 1,
        league_id: '',
        role_id: '',
        admin_id: ''
      },
      date: [],
      total: 0,
      visible: false,
      popData: {
        server_id: ''
      },
      userList: []
    };
  },
  created: function created() {
    this.getUserList();
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/user', ['usersList'])), {}, {
    getUserList: function getUserList() {
      var _this = this;

      this.usersList({
        page: 1,
        page_size: 1000
      }).then(function (res) {
        _this.userList = res.data;
      });
    },
    getList: function getList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.paramsData.server_id.length == 0)) {
                  _context2.next = 3;
                  break;
                }

                _this2.$message.error(_this2.$t('pleaseSelectServer'));

                return _context2.abrupt("return");

              case 3:
                _this2.paramsData.page = e;
                _this2.paramsData.start_time = _this2.date && _this2.date[0] ? _this2.$times.timestampToTime(_this2.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this2.paramsData.end_time = _this2.date && _this2.date[1] ? _this2.$times.timestampToTime(_this2.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this2.reqLoading = true;
                leagueIntroductionChangeList(_this2.paramsData).then(function (res) {
                  if (res.code == 200) {
                    _this2.tableData = res.data.data;

                    _this2.tableData.forEach(function (item) {
                      var foundData = _this2.serverListYJ.find(function (b) {
                        return b.serverID == item.server_id;
                      });

                      item.server_name = foundData.serverName;
                    });

                    _this2.total = res.data.total;
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    passClick: function passClick(row) {
      var _this3 = this;

      var params = {
        id: row.id,
        status: 1,
        env_id: this.paramsData.env_id,
        league_id: row.league_id,
        introduction: row.introduction,
        server_id: row.server_id
      };
      auditLeagueIntroduction(params).then(function (res) {
        if (res.code == 200) {
          _this3.getList(1);

          _this3.$message({
            message: _this3.$t('operationSuccess'),
            type: 'success'
          });
        }
      });
    }
  })
};